import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router';
import { Button, CardSkeleton, EmptyState, Page, PageHeader, Skeleton, } from '@platform/design-system';
import { useSession } from "../auth/session.js";
import { RouterLink } from "../router/router-link.js";
import { canOpen } from "./routes.js";
/** Anonymous → `/login` (remembering where to return); loading → a page-shaped skeleton. */
export function RequireSession({ children, loginPath = '/login', }) {
    const { status } = useSession();
    const location = useLocation();
    if (status === 'loading') {
        return (_jsxs(Page, { children: [_jsx(PageHeader, { title: _jsx(Skeleton, { width: 180, height: 26 }) }), _jsx(CardSkeleton, {})] }));
    }
    if (status === 'anonymous') {
        const returnTo = `${location.pathname}${location.search}`;
        return _jsx(Navigate, { to: `${loginPath}?returnTo=${encodeURIComponent(returnTo)}`, replace: true });
    }
    return children;
}
/** A signed-in person with no active tenant picks one first. */
export function RequireTenant({ children, pickerPath = '/switch-tenant', }) {
    const { principal } = useSession();
    if (principal && !principal.tenantId)
        return _jsx(Navigate, { to: pickerPath, replace: true });
    return children;
}
/** `canOpen` over the session principal. */
export function useCanOpen(route) {
    const { principal } = useSession();
    return canOpen(principal, route);
}
/** The page shown when the principal cannot open a route. */
export function NoAccess({ homeHref = '/' }) {
    return (_jsxs(Page, { children: [_jsx(PageHeader, { title: "No access" }), _jsx(EmptyState, { title: "You don't have access to this page", description: "Ask a workspace admin to change your role if you need it.", action: _jsx(Button, { component: RouterLink, href: homeHref, variant: "contained", children: "Back to home" }) })] }));
}
/**
 * Route gate: `@platform/authz`'s `canAccessRoute` over the contract route (or a `routeLike`
 * for a surface whose contract has not landed). Denied → the "No access" empty state.
 */
export function RequireRoute({ route, children, homeHref, }) {
    const allowed = useCanOpen(route);
    if (allowed)
        return children;
    return _jsx(NoAccess, { ...(homeHref ? { homeHref } : {}) });
}
//# sourceMappingURL=guards.js.map